// Cart Upsell – AJAX add to cart (v7 – usa sectionId nativo di Horizon)

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.cart-upsell__add-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  const originalText = btn.textContent.trim();
  btn.textContent = '…';
  btn.disabled = true;

  try {
    // Recupera il sectionId nativo dal componente Horizon
    const cartItemsEl = document.querySelector('cart-items-component');
    const sectionId = cartItemsEl ? cartItemsEl.sectionId || cartItemsEl.dataset.sectionId : null;
    console.log('[cart-upsell] sectionId:', sectionId);

    // Aggiunge al carrello richiedendo la sezione specifica
    const sectionsToFetch = sectionId ? [sectionId] : ['cart-drawer'];

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sectionsToFetch,
      }),
    });

    if (!addResponse.ok) {
      const err = await addResponse.json();
      throw new Error(err.description || 'Add failed');
    }

    const data = await addResponse.json();
    const sectionKey = sectionId || 'cart-drawer';
    const sectionHtml = data.sections?.[sectionKey];
    console.log('[cart-upsell] sectionKey:', sectionKey, '| html length:', sectionHtml?.length);

    if (sectionHtml) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');

      // Morphing di cart-items-component
      const newItems = doc.querySelector('cart-items-component');
      const currentItems = document.querySelector('cart-items-component');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
        // Triggera connectedCallback-like re-init
        currentItems.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } }));
      }

      // Aggiorna bubble contatore
      const newBubble = doc.querySelector('cart-bubble');
      const currentBubble = document.querySelector('cart-bubble');
      if (newBubble && currentBubble) {
        currentBubble.outerHTML = newBubble.outerHTML;
      }
    }

    btn.textContent = '✓ Aggiunto';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 1500);

  } catch (err) {
    console.error('[cart-upsell] error:', err.message);
    btn.textContent = '⚠ Errore';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  }
}, true);
